import { reactive, ref } from 'vue'
import { STEPS } from '../constants/steps.js'

export function useRegisterFlow(initialStep = STEPS.CHOOSE_ROLE) {
  const currentStep = ref(initialStep)
  const flowData = reactive({
    referralCode: '',
    companyName: '',
    referralError: '',
    practiceStep: 1,
    verificationMethod: null,
    needsMethodSelection: true,
    verifyEmail: '',
    verifyPhone: '',
  })

  const navigateTo = (step) => {
    currentStep.value = step
  }

  const setFlowData = (patch) => {
    Object.assign(flowData, patch)
  }

  return {
    currentStep,
    flowData,
    navigateTo,
    setFlowData,
  }
}
